import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PipeModule } from '../pipes';
import { LearnerStatsComponent } from './learner-stats.component';
import { AvatarModule } from '../avatar';
import { BarAvancementComponent } from './graph/BarAvancementChapitre/BarAvancementChapitre.component';
import { BarDetailNoteComponent } from './graph/BarDetailNoteChapitre/BarDetailNoteChapitre.component';
import { ListeModulesComponent } from './listeModules/listeModules.component';
import { CustomgridModule } from '../customgrid';

@NgModule({
  declarations: [
    LearnerStatsComponent,
    BarAvancementComponent,
    BarDetailNoteComponent,
    ListeModulesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PipeModule,
    AvatarModule,
    CustomgridModule
  ],
  exports: [
    LearnerStatsComponent
  ]
})

export class LearnerStatsModule { }
